import { useEffect } from 'react';
import useFetch from '../hooks/useFetch';
import { TemplateLoader } from '../template/TemplateLoader';
import type { LandingPayload } from '../template/contract';
import Loading from './Loading';
import Welcome from './Welcome';

function SiteLanding() {
  const { request, data, error } = useFetch<LandingPayload>();
  useEffect(() => { request('site/context'); }, [request]);
  if (error) return <Welcome />;
  if (!data) return <Loading />;
  return <TemplateLoader payload={data} view="landing" />;
}

export default SiteLanding;
